import * as React from "react";
import * as R from "ramda";
import {Form} from "react-final-form";
import {Col, Row, Glyphicon} from "react-bootstrap";
import TipoCliente from "../../general/componentes/TipoCliente";
import {connect} from "react-redux";
import {REQUEST} from "../../../config/ajax-wrapper";
import {Mensaje} from "../../general/componentes/Mensaje";
import {DotLoader} from "react-spinners";
import DatePickerSura from "../../general/componentes/DatePicker";
import {Documento} from "../../documentos/modelo/Documento";
import Oficinas from "../../general/componentes/Oficinas";
import {consultarReporte, obtenerXLSReporte} from "../modulos/reportesActions";
import EstadosDocumentos from "./EstadosDocumentos";
import {FiltroReporte} from "../modelo/Reporte"; 
import TipoTramite from "../../bandeja/componentes/TipoTramite";
import * as Moment from 'moment';
import NumericInput from "../../general/componentes/NumericInput";
import TipoIdentificacion from "../../general/componentes/TipoIdentificacion";
import TablaReportesEmpresas from "./TablaReportesEmpresas";
import TablaReportesIndependientes from "./TablaReportesIndependientes";
import {EstadosIndependiente as estadosIndependientes} from "../modelo/EstadosIndependiente";
import EstadosIndependiente from "./EstadosIndependiente";

class Reportes extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            visualizarTabla: false,
            filtroReporte: {}
        };
    }

    render() {
        const {documentos, estadoConsulta, estadoXLS, paginas, tamanoPagina, paginaActual} = this.props;
        const {visualizarTabla} = this.state;
        return (
            <div>
                <Row>
                    <Form
                        onSubmit={this.onSubmit}
                        validate={this.validate}
                        render={({handleSubmit, invalid, errors, form, submitting, pristine, values}) => (
                            <form onSubmit={handleSubmit}>
                                <h1 className={"title"}>Reporte Afiliaciones</h1>
                                
                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h3 className={"panel-title"}>Buscar Estado Afiliaciones</h3>
                                    </div>
                                    <div className={"card-body"}>

                                        {this.renderFiltros(values)}

                                        <Row className="form-group">
                                            <Col sm={2}>
                                                {documentos.length > 0 && visualizarTabla &&
                                                <a onClick={this.obtenerXLS} className="btns btn-success">
                                                    <Glyphicon className={"save-file"}
                                                               glyph={"save-file"}/> Exportar XLS

                                                </a>}
                                            </Col>
                                            <Col smOffset={6} sm={1}>
                                                <button type="button" className="btns btns-link"
                                                        onClick={form.reset}
                                                        disabled={submitting}>
                                                    Limpiar
                                                </button>
                                            </Col>
                                            <Col sm={1}>
                                                <button type="submit" className="btns btns-primary"
                                                        disabled={submitting || invalid}>
                                                    Consultar
                                                </button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </form>
                        )}
                    />
                </Row>
                <Row>
                    {this.renderXLS(estadoXLS)}
                    {this.renderDocumentos(documentos, estadoConsulta,paginas,tamanoPagina,paginaActual)}
                </Row>
            </div>
        );
    }

    renderFiltros(values: any) {
        return(
            <div>
                <Row className="form-group">
                    <Col sm={3}>
                        <label>Tipo Cliente</label>
                        <TipoCliente name="tipoCliente" excluir={["DE"]}/>
                    </Col>
                    <Col sm={3}>
                        <label>Estado</label>
                        {
                            values.tipoCliente !== 'OI' &&
                            <div>
                                <EstadosDocumentos name={"estado"}/>
                            </div> 
                            || values.tipoCliente === 'OI' &&
                            <div>
                                <EstadosIndependiente name={"estado"}/>
                            </div>
                        }
                    </Col>
                    <Col sm={3}>
                        <label>Fecha Inicio Radicacion</label>
                        <DatePickerSura name={"fechaInicio"}/>
                    </Col>
                    <Col sm={3}>
                        <label>Fecha Fin Radicacion</label>
                        <DatePickerSura name={"fechaFin"}/>
                    </Col>
                </Row>
                <Row className="form-group">
                    {
                        values.tipoCliente !== 'OI' &&
                        <div>
                            <Col sm={3}>
                                <label>Tipo de Tramite</label>
                                <TipoTramite name={"tipoTramite"}/>
                            </Col>
                            <Col sm={3}>
                                <label>Oficina Recibe</label>
                                <Oficinas name={"oficina"}/>
                            </Col>
                        </div>
                        || values.tipoCliente === 'OI' && 
                        <div>
                            <Col sm={3}>
                                <label htmlFor="tipoDocumento">Tipo Documento del Contratante</label>
                                <TipoIdentificacion name="tipoDocumento"/>
                            </Col>
                            <Col sm={3}>
                                <label htmlFor="documento">Documento del Contratante</label>
                                <NumericInput name="documento" placeholder="Ingrese un documento"/>
                            </Col>
                        </div>
                    }
                    <Col sm={3}>
                        <label>Fecha inicio Aprobacion/Rechazo</label>
                        <DatePickerSura name={"fechaInicioAprobacion"}/>
                    </Col>
                    <Col sm={3}>
                        <label>Fecha Fin Aprobacion/Rechazo</label>
                        <DatePickerSura name={"fechaFinAprobacion"}/>
                    </Col>
                </Row>
            </div>
        );
    }

    renderXLS = (estado: REQUEST) => {
        switch (estado) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={"Se ha presentado un error generando el XLS"}/>;
            case REQUEST.PENDING:
                return <DotLoader size={25}/>;
            case REQUEST.SUCCESS:
                    return (
                        <span>
                            <Mensaje type={"success"} mensaje={"Reporte generado exitosamente"}/>
                        </span>
                    );
            default:
                return false;
        }
    };

    renderDocumentos(documentos: Array<Documento>, estado: REQUEST,paginas: number, tamanoPagina: number, paginaActual: number) {
        const {visualizarTabla} = this.state; 
        if(visualizarTabla) {
            switch (estado) {
                case REQUEST.ERROR:
                    return <Mensaje type={"danger"} mensaje={"Se ha presentado un error obteniendo el reporte"}/>;
                case REQUEST.PENDING:
                    return <DotLoader size={25}/>;
                case REQUEST.SUCCESS:
                    if (!documentos || !documentos.length) {
                        return (
                            <span>
                                <Mensaje type={"danger"} mensaje={"No hemos encontrado documentos :("}/>
                            </span>
                        );
                    } else {
                        switch (this.state.filtroReporte.tipoCliente) {
                            case 'OI': {
                                return (
                                    <span>
                                        <TablaReportesIndependientes 
                                            documentos={documentos}
                                            filtroReporte={this.filtros()}
                                            paginas={paginas} 
                                            tamanoPagina={tamanoPagina}
                                            paginaActual={paginaActual}
                                            consultaPaginada={this.consultaPaginada}
                                            />
                                    </span>
                                );
                            }
                            default: {
                                return (
                                    <span>
                                        <TablaReportesEmpresas 
                                            documentos={documentos}
                                            filtroReporte={this.filtros()}
                                            paginas={paginas} 
                                            tamanoPagina={tamanoPagina}
                                            paginaActual={paginaActual}
                                            consultaPaginada={this.consultaPaginada}
                                            />
                                    </span>
                                );
                            }
                        }
                    }
                default:
                    return false;
            }
        } else
            return false;
    }

    filtros(): FiltroReporte {
        return  this.state.filtroReporte;
    }

    consultaPaginada = (filtro: FiltroReporte) => {
        this.props.dispatch(consultarReporte(filtro));
    };

    validate = values => {
        switch (values.tipoCliente) {
            case 'OI': {
                return this.validarFiltrosIndependientes(values);
            }
            default: {
                return this.validarFiltrosEmpresas(values);
            }
        }
    };

    validarFiltrosEmpresas(values: any) {
        const errors = {
            fechaInicio: undefined, 
            fechaFin: undefined,
            fechaInicioAprobacion: undefined, 
            fechaFinAprobacion: undefined
        };

        if (values.fechaInicio && !values.fechaFin)
            errors.fechaFin = "Por favor selecciona una fecha de fin";

        if (!values.fechaInicio && values.fechaFin)
            errors.fechaInicio = "Por favor selecciona una fecha de inicio";

        if (values.fechaInicio && values.fechaFin &&
            (Moment(values.fechaInicio).isAfter(Moment(values.fechaFin))))
            errors.fechaFin = "La fecha fin no puede ser anterior a la fecha de inicio";

        if (values.fechaInicioAprobacion && !values.fechaFinAprobacion)
            errors.fechaFinAprobacion = "Por favor selecciona una fecha de fin";

        if (!values.fechaInicioAprobacion && values.fechaFinAprobacion)
            errors.fechaInicioAprobacion = "Por favor selecciona una fecha de inicio";

        if (values.fechaInicioAprobacion && values.fechaFinAprobacion &&
            (Moment(values.fechaInicioAprobacion).isAfter(Moment(values.fechaFinAprobacion))))
            errors.fechaFinAprobacion = "La fecha fin no puede ser anterior a la fecha de inicio";

        if( !values.fechaInicioAprobacion && !values.fechaInicio)
            errors.fechaInicio = "Por favor seleccione una fecha como filtro para continuar";

        return errors;
    }

    validarFiltrosIndependientes(values: any) {
        const errors = {
            documento: undefined, 
            tipoDocumento: undefined, 
            fechaInicio: undefined, 
            fechaFin: undefined,
            fechaInicioAprobacion: undefined, 
            fechaFinAprobacion: undefined
        };

        if (values.tipoDocumento && !values.documento)
            errors.documento = "Por favor ingrese un documento";

        if (!values.tipoDocumento && values.documento)
            errors.tipoDocumento = "Por favor selecciona un tipo de documento";

        if (values.fechaInicio && !values.fechaFin)
            errors.fechaFin = "Por favor selecciona una fecha de fin";

        if (!values.fechaInicio && values.fechaFin)
            errors.fechaInicio = "Por favor selecciona una fecha de inicio";

        if (values.fechaInicio && values.fechaFin &&
            (Moment(values.fechaInicio).isAfter(Moment(values.fechaFin))))
            errors.fechaFin = "La fecha fin no puede ser anterior a la fecha de inicio";

        if (values.fechaInicioAprobacion && !values.fechaFinAprobacion)
            errors.fechaFinAprobacion = "Por favor selecciona una fecha de fin";

        if (!values.fechaInicioAprobacion && values.fechaFinAprobacion)
            errors.fechaInicioAprobacion = "Por favor selecciona una fecha de inicio";

        if (values.fechaInicioAprobacion && values.fechaFinAprobacion &&
            (Moment(values.fechaInicioAprobacion).isAfter(Moment(values.fechaFinAprobacion))))
            errors.fechaFinAprobacion = "La fecha fin no puede ser anterior a la fecha de inicio";

        if( !values.fechaInicioAprobacion && !values.fechaInicio)
            errors.fechaInicio = "Por favor seleccione una fecha como filtro para continuar";

        return errors;
    }

    onSubmit = values => {
        const dni = values.tipoDocumento && values.documento && values.tipoCliente === 'OI' ? (values.tipoDocumento + values.documento) : undefined;
        const oficina = values.oficina && values.tipoCliente !== 'OI' ? values.oficina.valueOf() : "";
        const tipoCliente = values.tipoCliente ? values.tipoCliente.valueOf() : "";
        const estado = values.estado ? (values.tipoCliente === 'OI' && estadosIndependientes.indexOf(values.estado) === -1 ? "" : values.estado.valueOf()) : "";
        const fechaInicio = values.fechaInicio ? values.fechaInicio.valueOf() : "";
        const fechaFin = values.fechaFin ? values.fechaFin.valueOf() : "";
        const fechaInicioAprobacion = values.fechaInicioAprobacion ? values.fechaInicioAprobacion.valueOf() : "";
        const fechaFinAprobacion = values.fechaFinAprobacion ? values.fechaFinAprobacion.valueOf() : "";
        const tipoTramite = values.tipoTramite && values.tipoCliente !== 'OI' ? values.tipoTramite.valueOf() : "";
        const registrosPorPagina = +this.props.tamanoPagina;
        const pagina = 0;

        const filtro: FiltroReporte = {
            dni,
            oficina, 
            tipoCliente, 
            estado, 
            fechaFin, 
            fechaInicio,
            fechaInicioAprobacion,
            fechaFinAprobacion,
            tipoTramite,
            registrosPorPagina,
            pagina
        };
        this.setState({filtroReporte: filtro, visualizarTabla: true});
        this.props.dispatch(consultarReporte(filtro));
    };

    limpiar = () => {
        this.setState({
            filtroReporte: {}
        });
    };

    obtenerXLS = () => {
        this.props.dispatch(obtenerXLSReporte(this.state.filtroReporte));
    }
}

export default connect((store: any) => {
    return {
        documentos: R.pathOr([], ["reportes", "documentos"])(store),
        estadoConsulta: R.pathOr([], ["reportes", "estado"])(store),
        estadoXLS: R.pathOr([], ["reportes", "estadoXLS"])(store),
        tamanoPagina: R.pathOr(10, ["reportes", "tamanoPagina"])(store),
        paginaActual: R.pathOr(1, ["reportes", "paginaActual"])(store),
        paginas: R.pathOr(1, ["reportes", "paginas"])(store)
    };
})(Reportes);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/reportes/componentes/Reportes.tsx